const MAPPINGS = {
    IdentifierNameToPrefix: {
        GoalHandle: 'GOAL-',
        ResourceId: 'RESOURCE-',
        ResourceTypeHandle: 'TYPE-',
        ToolHandle: 'TOOL-',
        WorkflowHandle: 'WORKFLOW-',
        WorkflowTraceHandle: 'WORKFLOW_TRACE-',
    },
};
export default MAPPINGS;
